import dayjs from 'dayjs';
import { DATE_FORMAT } from 'src/pages/Settings/users/const';

/** "This site was deleted on Sep 24, 2026"; without a date, "This site was deleted". */
export const getDeletedNotice = (entityLabel: string, deletedAt?: string | null): string => {
  const base = `This ${entityLabel} was deleted`;
  return deletedAt ? `${base} on ${dayjs(deletedAt).format(DATE_FORMAT)}` : base;
};
